export default {
  top_bar: 11,
  side_menu: 10,
  dropdown_menu: 10,
  sticky_menu: 9,
  bottom_bar: 9,
}
